function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Untitled 5");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "86 40 56 10 10 10 10 110 86 110"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  stroke: "#FF0099",
  strokeWidth: 2,
  strokeLinejoin: "round",
  points: "86 40 56 10 10 10 10 110 86 110"
});

var _ref6 = /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "10 10 56 10 76 30 76 0 0 0 0 100 10 100"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  stroke: "#FF0099",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "10 10 56 10 76 30 76 0 0 0 0 100 10 100"
});

var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "94px",
    height: "118px",
    viewBox: "0 0 94 118",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "result",
    transform: "translate(1.000000, 1.000000)"
  }, _ref4, _ref5, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M72.562,74.906 C72.562,86.866 62.866,96.562 50.906,96.562 C38.946,96.562 29.25,86.866 29.25,74.906 C29.25,62.946 38.946,53.25 50.906,53.25 C62.866,53.25 72.562,62.946 72.562,74.906 Z",
    id: "Path",
    fillOpacity: 0.298268138,
    fill: "#FF0099",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M72.562,74.906 C72.562,86.866 62.866,96.562 50.906,96.562 C38.946,96.562 29.25,86.866 29.25,74.906 C29.25,62.946 38.946,53.25 50.906,53.25 C62.866,53.25 72.562,62.946 72.562,74.906 Z M66.488,90.488 L92,116 M39.25,68 L51.25,68 M39.25,80 L63.25,80",
    id: "Shape",
    stroke: "#FF0099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _ref6, _ref7, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M85.424,40 L56,40 L56,10.576 L85.184,39.762 C85.1228052,39.6617443 85.1435292,39.5318826 85.2328883,39.4556531 C85.3222475,39.3794235 85.4537525,39.3794235 85.5431117,39.4556531 C85.6324708,39.5318826 85.6531948,39.6617443 85.592,39.762 L85.424,40 Z",
    id: "Path",
    fillOpacity: 0.300617351,
    fill: "#FF0099",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M85.424,40 L56,40 L56,10.576 L85.184,39.762 C85.1228052,39.6617443 85.1435292,39.5318826 85.2328883,39.4556531 C85.3222475,39.3794235 85.4537525,39.3794235 85.5431117,39.4556531 C85.6324708,39.5318826 85.6531948,39.6617443 85.592,39.762 L85.424,40 Z",
    id: "Path",
    stroke: "#FF0099",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search.874dec65.svg";
export { ForwardRef as ReactComponent };